export default __webpack_public_path__ + "static/media/logo.16236eb0.png";